














import Vue from "vue";
import { Model, Prop, Component, Ref, Watch } from "vue-property-decorator";

@Component
export default class ShareDialogStyleOptions extends Vue {

    // some input element with ref="linkField" 
    // @Ref()
    // private linkField: HTMLInputElement;

    // TEMP for testing
    private defaultStyle: any = {
        'id': '1',
        'name': 'Default Theme',
        'backgroundColor': '',
        'fontColor': '',
        'colorPrimary': '',
        'fontColorPrimary': '',
        'colorSecondary': '',
        'fontColorSecondary': '',
    }
    private styleObject: any = {
        'id': '2',
        'name': 'Pastel Theme 1',
        'backgroundColor': '#bed3d4',
        'fontColor': '#ffffff',
        'colorPrimary': '#e8caa4',
        'fontColorPrimary': '#ffffff',
        'colorSecondary': '#a1b872',
        'fontColorSecondary': '#ffffff',
    }

    private items: any[] = [this.defaultStyle, this.styleObject];
    private styles: any = {};

    @Model('updated:value', { type: Object })
    value: any;

    get style(): any {
        return this.value || this.defaultStyle;
    }

    set style(val: any) {
        this.$emit('updated:value', val);
    }


}
